<template>
  <div class="tekmodal">
    <!-- MODAL HEADER -->
    <div class="modalheader">
      <div class="headerleft">
        <div class="ico">
          <img src="../../assets/sidebar/tekenaars-ico.svg" alt />
        </div>
        <h4 class="header">Nieuwe Tekenaar</h4>
      </div>
      <div class="header-buttons">
        <div class="close-btn" @click="closemodal">
          <img src="../../assets/close-btn.png" alt class="close-x" />
        </div>
      </div>
    </div>

    <!-- SAVE CHANGES sectie -->
    <div class="savesection" v-if="isTekenaarVolledig == true" @click="saveChanges()">
      <span>Voeg deze tekenaar toe</span>
    </div>

    <!-- MODAL HEADER sectie -->
    <div class="section blue">
      <input
        v-model="tekenaar.voornaam"
        type="text"
        class="titeltekst tekstveld blue"
        placeholder="Voornaam"
      />
      <input
        v-model="tekenaar.achternaam"
        type="text"
        class="titeltekst tekstveld blue"
        placeholder="Achternaam"
      />
      <span class="titeltekst">{{ tekenaar.naam }}</span>
      <div class="threecolumnsholder">
        <div>
          <input
            type="text"
            class="tekstveld blue"
            v-model="tekenaar.email"
            placeholder="email-adres"
          />
          <input
            type="text"
            class="tekstveld blue"
            v-model="tekenaar.telefoonnummer"
            placeholder="telefoonnummer"
          />
        </div>
        <div>
          <input
            type="text"
            class="tekstveld blue"
            v-model="tekenaar.werkgebied"
            placeholder="werkgebied"
          />
          <input
            type="text"
            class="tekstveld blue"
            v-model="tekenaar.bedrijfsnaam"
            placeholder="bedrijfsnaam"
          />
        </div>
      </div>
      <div class="threecolumnsholder">
        <div>
          <input
            type="text"
            class="tekstveld blue"
            v-model="tekenaar.tekenprogramma"
            placeholder="tekenprogramma"
          />
          <input
            type="text"
            class="tekstveld blue"
            v-model="tekenaar.kvknummer"
            placeholder="kvk nummer"
          />
        </div>
        <div>
          <input
            type="text"
            class="tekstveld blue"
            v-model="tekenaar.woonplaats"
            placeholder="woonplaats"
          />
          <input type="text" class="tekstveld blue" v-model="tekenaar.adres" placeholder="adres" />
        </div>
      </div>
      <div class="threecolumnsholder">
        <div>
          <input
            type="text"
            class="tekstveld blue"
            v-model="tekenaar.opleiding"
            placeholder="opleiding"
          />
        </div>
        <div>
          <!-- hier passen 2 extra velden -->
        </div>
      </div>
      <div style="padding-top:20px;">
        <div class="discholder" style="padding-top:10px;padding-bottom:0px;">
          <span>Selecteer disciplines v.d. tekenaar</span>
          <Multiselect v-model="tekenaar.disciplines" :options="options" :multiple="true" />
        </div>
      </div>
    </div>

    <!-- MORE INFO sectie -->
    <div class="section">
      <span class="titeltekst">Aantekening</span>
      <div class="discholder" style="padding-top:10px;">
        <textarea class="aantekening" v-model="tekenaar.aantekening"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import Multiselect from "vue-multiselect";

export default {
  name: "TekModal",
  components: { Multiselect },

  data() {
    return {
      tekenaar: {
        voornaam: "",
        achternaam: "",
        email: "",
        werkgebied: "",
        telefoonnummer: "",
        woonplaats: "",
        opleiding: "",
        tekenprogramma: "",
        adres: "",
        kvknummer: "",
        bedrijfsnaam: "",
        disciplines: ["Bouwkunde"],
        aantekening: ""
      },
      options: [
        "Bouwkunde",
        "Werktuigbouwkunde",
        "Installatietechniek",
        "Elektrotechniek",
        "Brandpreventie",
        "Huisvesting",
        "Plattegronden",
        "Concepten - 3D Print",
        "Nen2580"
      ]
    };
  },
  computed: {
    isTekenaarVolledig() {
      const tek = this.tekenaar;
      if (
        tek.voornaam != "" &&
        tek.adres != "" &&
        tek.achternaam != "" &&
        tek.email != "" &&
        tek.werkgebied != "" &&
        tek.woonplaats != "" &&
        tek.opleiding != "" &&
        tek.tekenprogramma != "" &&
        tek.kvknummer != "" &&
        tek.telefoonnummer != "" &&
        tek.bedrijfsnaam != "" &&
        tek.disciplines != []
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    saveChanges() {
      if (confirm("Deze tekenaar toevoegen aan CAD-Tekenaar.com?")) {
        store
          .dispatch("addTekToDB", this.tekenaar)
          .then(this.$emit("close-Modal"));
      }
    },

    closemodal() {
      if (
        confirm("Deze tekenaar wordt niet opgeslagen. Zeker weten afsluiten?")
      ) {
        this.$emit("close-Modal");
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
@media screen and (max-width: 663px) {
  .tekmodal {
    z-index: 2;
    position: fixed;
    overflow-y: scroll;
    left: auto;
    top: 0%;
    right: 0%;
    bottom: 0%;
    width: 100%;
    background-color: #fff;
    box-shadow: -20px 0 50px 0 rgba(0, 0, 0, 0.11);
    padding-bottom: 100px;
  }
}

.tingting {
  position: absolute;
  right: 40px;
}

.opdracht-bedrijfsnaam {
  white-space: nowrap;
}

.annuleersection {
  padding: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e4ecfa;
  cursor: pointer;
}
.annuleersection:hover {
  background-color: #e3170a87;
}

.discipline-orange {
  background-color: #ff9323;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 13px;
  color: white;
  border: 2px solid white;
}

.herobarting {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

#cars {
  cursor: pointer;
  font-weight: 500;
  border: none;
  -webkit-appearance: none;
  background: none;
  color: #fff;
  font-size: 14px;
  /* width: inherit; */
  font-family: poppins;
  text-align: center;
}

.blue {
  background-color: #e4ecfa;
  /* color: #fff; */
  position: sticky !important;
  top: 70px;
  z-index: 1;
}

.blue.tekstveld {
  background: none;
}

/* .tekstveld.blue:hover {
        background-color: #1b4d8d;
    }
    .tekstveld.blue:focus {
        background-color: #1b4d8d;
    } */

.header {
  color: #fff;
  font-weight: 600;
  padding-right: 30px;
  font-size: 18px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.header-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.deletebutton {
  background-color: #ff9326;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  cursor: pointer;
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1px;
}

.close-btn {
  width: 24px;
  height: 24px;
  display: flex;
  cursor: pointer;
  transition: 0.3s;
}
.close-btn:hover {
  transform: scale(1.2);
}

.delete-image {
  height: 16px;
}

.savesection {
  background-color: #ff9326;
  color: #fff;
  display: flex;
  width: 100%;
  max-width: 520px;
  padding: 24px;
  justify-content: center;
  cursor: pointer;
  font-weight: 600;
  position: fixed;
  bottom: 0;
  z-index: 1;
}

.opdracht {
  padding: 10px 0px;
  border-bottom: 1px solid #e4ecfa;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.opdracht:hover {
  background-color: #e4ecfa;
}

.tekmodal {
  z-index: 4;
  position: fixed;
  overflow-y: scroll;
  left: auto;
  max-width: 520px;
  top: 0%;
  right: 0%;
  bottom: 0%;
  min-width: 520px;
  background-color: #fff;
  box-shadow: -20px 0 50px 0 rgba(0, 0, 0, 0.11);
}
.modalheader {
  display: flex;
  height: 70px;
  padding: 0 25px;
  justify-content: space-between;
  align-items: center;
  background-color: #1b4d8d;
  color: white;
  font-size: 16px;
  font-weight: 600;
  position: sticky;
  top: 0px;
  z-index: 5;
}

.section {
  padding: 40px;
  position: relative;
  border-bottom: 1px solid #e4ecfa;
}

.section2 {
  padding: 40px;
  position: relative;
  padding-bottom: 300px;
}

.titeltekst {
  font-weight: 600;
  font-size: 20px !important;
}

.threecolumnsholder {
  display: flex;
  justify-content: space-between;
  align-items: top;
  width: 100%;
}

.threecolumnsholder div {
  width: 100%;
  padding-top: 15px;
  font-size: 15px;
  display: flex;
  flex-direction: column;
}

.vertical {
  display: flex;
  flex-direction: column;
}

.discipline {
  background-color: #e4ecfa;
  border-radius: 100px;
  padding: 5px 10px;
  margin-bottom: 15px;
  display: inline-block;
  /* display: flex;
        align-items: center;
        justify-content: center; */
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-right: 7px;
  /* border: 2px solid white; */
}

.tekstveld {
  font-size: 15px;
  font-family: "Poppins", sans-serif;
  border: 0px;
}
.tekstveld:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.tekstveld:focus {
  background-color: #ffdab5;
}

.aantekening {
  font-family: "Poppins", sans-serif;
  height: 170px;
  font-size: 16px;
  border-width: 0px;
  width: 100%;
  /* background-color: #E4ECFA; */
  /* padding: 14px; */
  /* border-radius: 5px; */
}
.aantekening:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.aantekening:focus {
  background-color: #ffdab5;
}
</style>
